<script setup lang="ts">
import { MContainer, TitleSmall, MContainerRow } from "@xlabmedical/medic-web-framework";
import { computed } from "vue";

const props = defineProps<{
    implantList: any;
    isPopover?: boolean;
}>();

const implantName = (manufacturer: string, name: string, size: string, sellingCode: string) => {
    let tmpStr = manufacturer + " " + name + "\n" + size;
    if (sellingCode) {
        tmpStr += " (" + sellingCode + ")";
    }
    return tmpStr;
};

const hasImplants = computed(() => {
    return props.implantList.length > 0;
});
</script>

<template>
    <MContainer v-if="hasImplants" :class="{ 'gap-3': isPopover, 'flex-auto': true, 'px-4': true, '-mt-1': true, 'flex-col': true }">
        <MContainer class="grid grid-cols-3 gap-4" style="grid-template-columns: 30px 1fr 1fr">
            <TitleSmall>{{ $t("shared.tooth") }}</TitleSmall>
            <TitleSmall>{{ $t("shared.implant") }}</TitleSmall>
            <TitleSmall>{{ $t("shared.abutment") }}</TitleSmall>
        </MContainer>
        <MContainer v-for="(implant, index) in props.implantList" :key="implant.implant.name + index" class="grid grid-cols-3 gap-4" style="grid-template-columns: 30px 1fr 1fr">
            <span class="justify-center flex">{{ implant.implant.name }}</span>
            <span style="white-space: break-spaces">
                {{
                    implantName(
                        implant.implant.implantInfo.manufacturerName,
                        implant.implant.implantInfo.modelName,
                        implant.implant.implantInfo.implantOriginalName,
                        implant.implant.implantInfo.sellingCode,
                    )
                }}
            </span>
            <span style="white-space: break-spaces">
                {{
                    implantName(
                        implant.abutment?.manufacturerName || "",
                        implant.abutment?.modelName || "",
                        implant.abutment?.name || "",
                        implant.abutment?.abutmentSellingCode || "",
                    )
                }}
            </span>
        </MContainer>
    </MContainer>
    <MContainerRow v-else class="px-4">
        <span>{{ $t("web-rg.noDataToDisplay") }}</span>
    </MContainerRow>
</template>

<style scoped></style>
